import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'attributeValue',
    serviceName: 'shopadmin',
    query: gql`
      query attributeValue($ids: [String]) {
        attributeValue(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
